import "./Project2Layout.scss";

export default function Project2Layout({ projectData = {} }) {
  return (
    <div className={`project-layout2 ${projectData.projectName}`}>
      {projectData.projectTitle && (
        <div className="project-title">
          <div className="main-title">
            <h3>{projectData.projectTitle}</h3>
          </div>
        </div>
      )}
      {projectData.titleLogoSrc && (
        <div className="project-container2">
          <div className="top-logo d-flex justify-content-end align-items-center">
            <img src={projectData?.titleLogoSrc} alt="logo" />
          </div>
        </div>
      )}
      {projectData.bannerImage && (
        <div className="d-flex justify-content-end align-items-center wrap banner-first">
          <img
            src={projectData.bannerImage}
            className={`${projectData.style}`}
            alt="bannerimage"
          />
        </div>
      )}

      {projectData?.description && (
        <div className="project-description">
          <div className="description">
            <div class="l-wrapper">
              <div class="text-section">
                <div class="wrap-before"></div>
                <div class="wrap-after"></div>
                {projectData.description}
              </div>
            </div>
          </div>
        </div>
      )}

      {projectData.bannerImage2 && (
        <div className="banner-second">
          <div className="banner-image">
            <img
              src={projectData.bannerImage2}
              className={`${projectData.style}`}
              alt="bannerimage"
            />
          </div>
        </div>
      )}
      {projectData.projectName === "coa" ? (
        <div className="coa-project-images">
          {projectData?.projectDetails?.map((details, index) =>
            details.gridLR ? (
              <div className="coa-project-container">
                <div
                  className={`banner-container d-flex justify-content-center align-items-center`}
                >
                  <div className={`LR-image ${details.imgWidth}`}>
                    <img
                      src={details.imageSrc}
                      alt="Banner"
                      className="banner-image"
                    />

                    {/* Left Side Texts */}
                    <div className="grid-vertical-text one left-text offset-single-lineL top-200">
                      <span className="vertical">
                        resource block - concrete
                      </span>
                    </div>
                    <div className="grid-vertical-text two left-text offset-single-lineL">
                      <span className="vertical">
                        convention block - stone masonry
                      </span>
                    </div>

                    {/* Right Side Texts */}
                    <div className="grid-vertical-text three offset-single-lineR right-text">
                      <span className="vertical">
                        research block - metal fabrication
                      </span>
                    </div>
                    <div className="grid-vertical-text four right-text offset-single-lineR center-vertically">
                      <span className="vertical">
                        admin block - rammed earth
                      </span>
                    </div>
                    <div className="grid-vertical-text five right-text offset-single-lineR bottom-0">
                      <span className="vertical">
                        archives block - wood construction
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="coa-project-container">
                <div
                  class={`banner-container project-image${index + 1}`}
                  key={index}
                >
                  <img
                    src={details.imageSrc}
                    alt="Banner"
                    class={`banner-image mx-100 ${details.imgWidth}`}
                  />
                  <div
                    className={`vertical-text wrapv left-text ${
                      details?.multiLine ? "two-line" : "offset-single-lineL"
                    }`}
                  >
                    <span className="vertical">{details.leftText}</span>
                  </div>
                  <div class="vertical-text wrapv right-text offset-single-lineR">
                    <span className="vertical">{details.rightText}</span>
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      ) : (
        <div
          className={`vertical-image-grid ${
            projectData?.projectName === "man" ||
            projectData?.projectName === "method"
              ? "project-container2"
              : null
          }`}
        >
          <div className="grid-images">
            {!projectData.textLR
              ? projectData?.projectDetails?.map((details, index) => (
                  <div
                    className={`image-container wrap d-flex ${
                      details?.flexAlign
                    } ${
                      projectData?.gridAlign ? projectData?.gridAlign : null
                    } ${projectData.projectName}`}
                    key={index}
                  >
                    <div className={`image-wrap ${details.imgWidth}`}>
                      {details?.verticalText && (
                        <div className="wrapv">
                          <div className="vertical">
                            {details?.verticalText}
                          </div>
                        </div>
                      )}
                      <div className="title-container">
                        {details?.title && (
                          <h4 className="title">{details?.title}</h4>
                        )}
                        {details?.subTitle && (
                          <div className="subtitle">
                            <div class="subtitle-text-section">
                              <div class="wrap-before"></div>
                              <div class="wrap-after"></div>
                              <p>{details?.subTitle}</p>
                            </div>
                          </div>
                        )}
                      </div>
                      {details?.imageSrc && (
                        <img
                          src={details?.imageSrc}
                          className={`${projectData.style} `}
                          alt="grid-images"
                        />
                      )}

                      {details?.description && (
                        <div className="project-description">
                          <div className="description">
                            <div class="l-wrapper">
                              <div class="text-section">
                                <div class="wrap-before"></div>
                                <div class="wrap-after"></div>
                                {details.description}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))
              : projectData?.projectDetails?.map((details, index) => (
                  <>
                    {details.gridLR ? (
                      <div
                        className={`banner-container d-flex justify-content-center align-items-center`}
                      >
                        <div className={`LR-image ${details.imgWidth}`}>
                          <img
                            src={details.imageSrc}
                            alt="Banner"
                            className="banner-image"
                          />

                          {/* Left Side Texts */}
                          <div className="grid-vertical-text one left-text offset-single-lineL top-200">
                            <span className="vertical">three</span>
                          </div>
                          <div className="grid-vertical-text two left-text offset-single-lineL bottom-0">
                            <span className="vertical">two</span>
                          </div>

                          {/* Right Side Texts */}
                          <div className="grid-vertical-text three offset-single-lineR right-text">
                            <span className="vertical">three</span>
                          </div>
                          <div className="grid-vertical-text four right-text offset-single-lineR center-vertically">
                            <span className="vertical">four</span>
                          </div>
                          <div className="grid-vertical-text five right-text offset-single-lineR bottom-0">
                            <span className="vertical">five</span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        class={`banner-container project-image${index + 1}`}
                        key={index}
                      >
                        <img
                          src={details.imageSrc}
                          alt="Banner"
                          class={`banner-image mx-100 ${details.imgWidth}`}
                        />
                        <div
                          className={`vertical-text wrapv left-text ${
                            details?.multiLine ? "" : "offset-single-lineL"
                          }`}
                        >
                          <span className="vertical">{details.leftText}</span>
                        </div>
                        <div class="vertical-text wrapv right-text offset-single-lineR">
                          <span className="vertical">{details.rightText}</span>
                        </div>
                      </div>
                    )}
                  </>
                ))}
          </div>
        </div>
      )}
    </div>
  );
}
